var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgInvalidTicket = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4237 18.4639L4.92896 16.2957C4.63762 16.1797 4.40743 15.962 4.28835 15.6898C4.16926 15.4176 4.17089 15.1129 4.29288 14.8419L4.88836 13.5886L9.4357 3.67489C9.56095 3.40509 9.79605 3.19192 10.09 3.08163C10.3839 2.97135 10.7129 2.97286 11.0056 3.08583L12.1019 3.56209C11.9995 3.76498 11.9428 3.985 11.935 4.20881C11.9272 4.43263 11.9686 4.65557 12.0566 4.86415C12.1446 5.07272 12.2774 5.26258 12.4469 5.42222C12.6165 5.58186 12.8193 5.70796 13.043 5.79288C13.2668 5.8778 13.5068 5.91977 13.7486 5.91625C13.9904 5.91273 14.2289 5.86379 14.4496 5.7724C14.6704 5.681 14.8688 5.54906 15.0329 5.38456C15.1969 5.22006 15.3232 5.02643 15.4041 4.8154L16.5545 5.25405C16.8262 5.37888 17.0371 5.59407 17.145 5.85661C17.2529 6.11916 17.2498 6.40974 17.1364 6.67029L15.0329 11.0526",
    stroke: "#767380",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2301 18.6622C13.9241 18.9682 13.9241 19.4644 14.2301 19.7704C14.5361 20.0764 15.0322 20.0764 15.3382 19.7704L16.9999 18.1085L18.6618 19.7705C18.9678 20.0765 19.4639 20.0765 19.7699 19.7705C20.0759 19.4645 20.0759 18.9683 19.7699 18.6623L18.108 17.0003L19.7705 15.3377C20.0765 15.0317 20.0765 14.5355 19.7705 14.2295C19.4645 13.9235 18.9684 13.9235 18.6624 14.2295L16.9999 15.8921L15.3376 14.2296C15.0316 13.9236 14.5355 13.9236 14.2295 14.2296C13.9235 14.5356 13.9235 15.0318 14.2295 15.3378L15.8919 17.0003L14.2301 18.6622Z",
    fill: "#767380"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInvalidTicket, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/invalidTicket.b8ba22bd.svg";
export { ForwardRef as ReactComponent };